import { getBoundedValue } from 'utils/math/math.utils';
import { getWeatherTimeString } from '../../../utils/forecast.utils';

export const getSelectorListStyle = (selectorMode, compactWeather1x2Columns) => {
  if (selectorMode === 'grid') {
    return {
      display: 'grid',
      rowGap: 5,
      columnGap: 5,
      minWidth: 0,
      gridTemplateColumns: `repeat(${compactWeather1x2Columns}, minmax(0, 1fr))`,
      height: '100%',
    };
  }

  return {
    display: 'flex',
    flex: '1 1 0',
    height: '100%',
    minWidth: 0,
    gap: 8,
  };
};

export const getHourlyForecastWidgetLayout = ({ containerSizePx, layoutSize, dimensions }) => {
  const columnCount = Math.max(1, Number(dimensions?.[0]) || 1);
  const isSingleColumnWidget = columnCount === 1;

  const containerWidth = Number.isFinite(containerSizePx?.width)
    ? containerSizePx.width
    : layoutSize.widgetWidth * columnCount;
  const baseFontSize = Number.isFinite(layoutSize?.baseFontSize) ? layoutSize.baseFontSize : 12;

  // Arrow width is between 30 and 50 pixels
  const arrowButtonWidth = getBoundedValue(
    Math.round(containerWidth * (isSingleColumnWidget ? 0.11 : 0.065)),
    30,
    50,
  );
  const arrowIconSize = getBoundedValue(Math.round(arrowButtonWidth * 0.42), 14, 20);

  const compact1x1VisibleCount = containerWidth <= 340 ? 2 : 3;
  const compact1x2ColumnCount = containerWidth < 360 ? 2 : containerWidth < 480 ? 3 : 4;

  const rowTileIconSize = getBoundedValue(Math.round(containerWidth * 0.09), 26, 38);
  const tileIconSize = getBoundedValue(Math.round(containerWidth * 0.11), 30, 46);
  const tileFontSize = getBoundedValue(
    Math.min(baseFontSize, Math.round(containerWidth * 0.04)),
    11,
    14,
  );
  const tileTextStyle = {
    fontSize: tileFontSize,
    lineHeight: 1.05,
  };

  return {
    arrowButtonWidth,
    arrowIconSize,
    compact1x1VisibleCount,
    compact1x2ColumnCount,
    rowTileIconSize,
    tileIconSize,
    tileTextStyle,
  };
};

export const getHourlyForecastTileAriaLabel = (item) => {
  const forecastTime = getWeatherTimeString(item?.iso8601, true);
  const temperatureLabel =
    item?.temperature === null || item?.temperature === undefined
      ? 'temperature unavailable'
      : `${item.temperature} degrees Fahrenheit`;

  return `Select hourly forecast for ${forecastTime || 'this time'}, ${temperatureLabel}`;
};
